module.exports = __webpack_public_path__ + "static/img/slider-11.8227588.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-11.jpg
// module id = ufSB
// module chunks = 0